export type Config = {
  ngwUrl: string;
  auth?: {
    login: string;
    password: string;
  };
  webmapId: number;
  hiddenLayerIds: number[];
  bufferMeters: number;
  maxExtentArea?: number;
  searchResourceId?: number;
  termsAndConditionsUrl?: string;
};

export const CONFIG: Config = {
  ngwUrl: import.meta.env.DEV ? "" : "https://rskomtesting.nextgis.com",
  webmapId: 27,
  hiddenLayerIds: [],
  bufferMeters: 500,
  maxExtentArea: 10_000_000,
};

export function updateConfig({
  ngwUrl,
  hidden_layers_list,
  max_extent_area,
  search_resource_id,
  terms_and_conditions_url,
  settlements_id,
  ...config
}: Partial<Config> & {
  hidden_layers_list?: string;
  max_extent_area?: number;
  settlements_id?: string;
  search_resource_id?: string;
  terms_and_conditions_url?: string;
}) {
  Object.assign(CONFIG, {
    ngwUrl: import.meta.env.DEV
      ? ""
      : ngwUrl || "https://rskomtesting.nextgis.com",

    ...config,

    ...(hidden_layers_list && {
      hiddenLayerIds: hidden_layers_list.split(",").map(Number),
    }),

    ...(max_extent_area != null && {
      maxExtentArea: max_extent_area,
    }),

    ...(search_resource_id != null && {
      searchResourceId: Number(search_resource_id),
    }),

    ...(terms_and_conditions_url && {
      termsAndConditionsUrl: terms_and_conditions_url,
    }),

    ...(settlements_id != null && {
      settlementsId: Number(settlements_id),
    }),
  });
}

export const HIGHLIGHT_LAYER_ID = "rskom-identify-highlight";
